import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ChevronRight } from 'lucide-react';
export function SecurityScore() {
  const score = 85;
  return <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl p-6 text-white shadow-lg relative overflow-hidden" data-id="element-2071">
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl" data-id="element-2072"></div>

      <div className="flex items-start justify-between relative z-10" data-id="element-2073">
        <div data-id="element-2074">
          <h3 className="text-lg font-bold mb-1 flex items-center" data-id="element-2075">
            <ShieldCheck className="h-5 w-5 mr-2 text-blue-300" data-id="element-2076" />
            Security Score
          </h3>
          <p className="text-blue-200 text-sm" data-id="element-2077">Your account protection level</p>
        </div>
        <div className="text-right" data-id="element-2078">
          <span className="text-3xl font-bold" data-id="element-2079">{score}</span>
          <span className="text-blue-300 text-sm" data-id="element-2080">/100</span>
        </div>
      </div>

      <div className="mt-6 mb-2" data-id="element-2081">
        <div className="w-full bg-blue-950/50 rounded-full h-2 overflow-hidden" data-id="element-2082">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${score}%`
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className="bg-green-400 h-full rounded-full" data-id="element-2083" />
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-blue-700/50" data-id="element-2084">
        <p className="text-xs text-blue-200 font-medium uppercase tracking-wide mb-2" data-id="element-2085">
          Recommendations
        </p>
        <button className="w-full flex items-center justify-between text-sm bg-blue-800/50 hover:bg-blue-700/50 p-2 rounded-lg transition-colors" data-id="element-2086">
          <span className="flex items-center" data-id="element-2087">
            <div className="w-2 h-2 rounded-full bg-yellow-400 mr-2" data-id="element-2088"></div>
            Enable 2FA
          </span>
          <ChevronRight className="h-4 w-4 text-blue-300" data-id="element-2089" />
        </button>
      </div>
    </div>;
}